<template>
  <div class="max-w-full truncate text-gray-900 md:text-xl">
    <slot />
  </div>
</template>
